import { TagDescription } from '@reduxjs/toolkit/query';

export const refetchTagsWithAccountParam: Array<
  TagDescription<'Projects' | 'Accounts' | 'UsersAll' | 'ProjectById'>
> = ['Projects', 'Accounts', 'UsersAll', 'ProjectById'];

export const refetchTagsWithAccountParamForSubscription: Array<
  TagDescription<'PaymentMethods' | 'Payments' | 'ProjectPlans' | 'SubscriptionPermission'>
> = ['PaymentMethods', 'Payments', 'ProjectPlans', 'SubscriptionPermission'];

export const refetchQuerysWithAccountParam = [
  'getAllProjects',
  'getUsersAll',
  'getAccounts',
  'getProjectById',
  'createProject',
  'deleteProject',
  'updateAccounts',
  'updateProject',
  'addProjectTeamMembers',
  'createUser',
  'deleteProjectTeamMembers',
  'updateUser',
  'getProjectTeamMembers',
  'newLimitProjectTeamMembers',
  'getPaymentMethods',
  'setDefaultPaymentMethod',
  'getPayments',
  'getAllPlans',
  'createProjectPlans',
  'getProjectsSubscriptions',
  'createSubscription',
  'deleteSubscription',
  'subscriptionAddItem',
  'getInvoicePdf',
  'deletePaymentMethods',
  'extendProjectPlan',
  'deExtendProjectPlan',
  'getSubscriptionPermission',
  'setSubscriptionPermission',
  'activateProject',
  'deactivateProject',
  'deleteIntegration',
  'addIntegration',
  'updateIntegration',
  'getProjectFiles',
  'addProjectFile',
  'addProjectDocument',
  'updateProjectFiles',
  'deleteProjectFiles',
  'deleteProjectFile',
  'fetchCoAgentAnalytics',
  'getCoCustomerTimeSeries',
  'getCoCustomerAggregated',
  'getCoCustomerChatsCount',
  'createSubscription',
  'changeSubscription',
  'cancelSubscription',
  'createPaymentIntent',
  'projectDemoMode',
  'getProjectChats',
  'getKnowledgeBase',
  'createKnowledgeBase',
  'deleteKnowledgeBase',
  'editKnowledgeBaseName',
  'updateKnowledgeBaseProjects',
  'getPlaygroundChat',
  'createPlaygroundChat',
  'getKnowledgeBaseById',
  'getKnowledgeBaseFiles',
  'addKnowledgeBaseFile',
  'updateKnowledgeBaseFiles',
  'updateKnowledgeBaseFile',
  'deleteKnowledgeBaseFiles',
  'addKnowledgeBaseDocument',
  'getKnowledgeBaseCollectors',
  'createKnowledgeBaseCollector',
  'updateKnowledgeBaseCollector',
  'deleteKnowledgeBaseCollector',
  'setupKnowledgeBaseCollector',
  'runKnowledgeBaseCollector',
  'addPaymentMethods',
  'zendeskEmailIntegrationAutoSetup',
  'assignProjectKnowledgeBase',
  'unassignProjectKnowledgeBase',
  'zendeskChatIntegrationAutoSetup',
  'getZendeskChatWidgets',
  'getDefaultConfigurationTemplateFields',
  'getAllConfigurationSettings',
  'createConfigurationSettings',
  'deployConfigurationSettings',
  'getConfigurationSettingsPrompt',
  'updateConfigurationSettingsPrompt',
  'getProjectsStatisticsSummary',
  'getKnowledgeBaseFileById',
  'getZendeskEmailStatusFields',
  'getZendeskEmailAssigneeFields',
  'getZendeskEmailGroupsFields',
  'getFreshdeskEmailAgents',
  'getFreshdeskEmailGroups',
  'getZohoSalesIQSetup',
  'getZohoEmailSetup',
  'freshdeskEmailIntegrationAutoSetup',
  'getZendeskConsentLink',
  'getKnowledgeBaseCollectorZendeskConsentLink',
];

export const refetchQuerysWithProjectTypeParam = [
  'getProjectById',
  'updateProject',
  'deleteProject',
  'createProject',
  'addProjectTeamMembers',
  'getProjectTeamMembers',
  'deleteProjectTeamMembers',
  'newLimitProjectTeamMembers',
  'activateProject',
  'deactivateProject',
  'addIntegration',
  'updateIntegration',
  'deleteIntegration',
  'getProjectFiles',
  'addProjectFile',
  'addProjectDocument',
  'updateProjectFiles',
  'deleteProjectFiles',
  'deleteProjectFile',
  'fetchCoAgentAnalytics',
  'getCoCustomerTimeSeries',
  'getCoCustomerAggregated',
  'getCoCustomerChatsCount',
  'getProjectChats',
  'getPlaygroundChat',
  'createPlaygroundChat',
  'getZendeskConsentLink',
  'getKnowledgeBaseCollectorZendeskConsentLink',
];
